/**
 * Turkish to English character conversion for URL slugs
 */
export const turkishToEnglish = (str) => {
  if (!str) return '';
  
  return str
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .trim();
};

/**
 * Generate venue URL from venue data
 * @param {Object} venue - Venue object with cityName, districtName, and slug
 * @returns {string} - Full venue URL path (e.g., /bursa/osmangazi/masal-organizasyon-cafe)
 */
export const getVenueUrl = (venue) => {
  if (!venue) return '/';
  
  const citySlug = venue.citySlug || turkishToEnglish(venue.cityName || 'city');
  const districtSlug = venue.districtSlug || turkishToEnglish(venue.districtName || 'district');
  const venueSlug = venue.slug || 'venue';
  
  return `/${citySlug}/${districtSlug}/${venueSlug}`;
};
